import { useState, useCallback } from "react";
import axios from "axios";
import { UrlApi } from "../services/apirest";

export const useFileUpload = () => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  /**
   * Sube uno o varios archivos al servidor usando una petición POST.
   *
   * @function
   * @async
   * @param {FileList|File[]} fileList - Lista de archivos a subir.
   * @param {string|number} fileId - Identificador único relacionado con la subida.
   * @returns {Promise<>} Retorna void si la subida es exitosa, o null si ocurre un error.
   *
   * @example
   * // Ejemplo de uso en un componente React:
   * const handleUpload = async (event) => {
   *   const files = event.target.files;
   *   await uploadFile(files, "uuid");
   * };
   */
  const uploadFile = useCallback(async (fileList, fileId) => {
    setIsUploading(true);
    setUploadError(null);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("uid", fileId);

    // Convertir FileList o cualquier iterable a Array para manejo uniforme
    const files = fileList instanceof FileList ? Array.from(fileList) : (Array.isArray(fileList) ? fileList : [fileList]);

    files.forEach((file) => {
      formData.append("archivo", file);
    });
    try {
      const { data } = await axios.post(
        `${UrlApi}/uploadfiles/uploadfiles`,
        formData,
        {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          },
        }
      );
      setUploadProgress(100);
      return data; // {status:true , message :"Se guardaron los archivos correctamente"}
    } catch (error) {
      return setUploadError(error.data.message || "Error al subir archivo"); // {status:false , message :"Error Message" }
    } finally {
      setIsUploading(false);
    }
  }, []);

  return {
    uploadFile,
    uploadProgress,
    isUploading,
    uploadError,
  };
};
